import { render, staticRenderFns } from "./ScheduleSetup.vue?vue&type=template&id=82dae92a&scoped=true&"
import script from "./ScheduleSetup.vue?vue&type=script&lang=ts&"
export * from "./ScheduleSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82dae92a",
  null
  
)

export default component.exports